import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@core/analytics-legacy';
import { SharedEmailProviders } from '@core/email-providers-types';

@Injectable({ providedIn: 'root' })
export class SharedMailboxesAnalytics extends AnalyticsBase {
  public readonly namespace = 'Shared Mailboxes';
  public readonly requireViewContext: boolean = false;

  public trackConnectMailbox(provider: `${SharedEmailProviders}`) {
    this.track('ConnectMailbox', { provider });
  }

  public trackArchive() {
    this.track('Archive');
  }

  public trackArchiveWithAutomatedAction() {
    this.track('trackArchiveWithAutomatedAction');
  }

  public trackReconnect() {
    this.track('Reconnect');
  }
}
